import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('testing');
const GET_ALL_TESTING = define('GET_ALL_TESTING', true);
const CREATE_TESTING = define('CREATE_TESTING', true);
const GET_TESTING = define('GET_TESTING', true);
const UPDATE_TESTING = define('UPDATE_TESTING', true);
const DELETE_TESTING = define('DELETE_TESTING', true);

const initialState = {
  isLoadingList: true,
  tests: [],
  isLoadingTest: true,
  test: null,
  processing: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ALL_TESTING.PENDING:
      return {
        ...state,
        isLoadingList: true
      };
    case GET_ALL_TESTING.RESOLVED:
      return {
        ...state,
        isLoadingList: false,
        tests: action.data
      };
    case GET_TESTING.PENDING:
      return {
        ...state,
        isLoadingTest: true
      };
    case GET_TESTING.RESOLVED:
      return {
        ...state,
        isLoadingTest: false,
        test: action.data
      };
    case CREATE_TESTING.PENDING:
    case UPDATE_TESTING.PENDING:
    case DELETE_TESTING.PENDING:
      return {
        ...state,
        processing: true,
      };
    case CREATE_TESTING.RESOLVED:
    case UPDATE_TESTING.RESOLVED:
    case DELETE_TESTING.RESOLVED:
      return {
        ...state,
        processing: false,
      };
    default:
      return state;
  }
}

export const actions = {
  loadAllTesting: () => ({
    type: GET_ALL_TESTING,
    promise: api.get('/configs/user'),
    error: 'Unable to load A/B Testing list'
  }),
  createNewTesting: (data) => ({
    type: CREATE_TESTING,
    promise: api.post('/configs/user', data),
    success: 'New Testing has been created',
    error: 'Unable to create new testing'
  }),
  loadTesting: (id) => ({
    type: GET_TESTING,
    promise: api.get(`/configs/user/${id}`),
    error: 'Unable to load testing detail'
  }),
  updateTesting: (id, data) => ({
    type: UPDATE_TESTING,
    promise: api.put(`/configs/user/${id}`, data),
    success: 'Update testing config successfully',
    error: 'Unable to update testing config',
  }),
  deleteTesting: (id) => ({
    type: DELETE_TESTING,
    promise: api.delete(`/configs/user/${id}`),
    success: 'Delete testing config successfully',
    error: 'Unable to delete testing config',
  })
};



// WEBPACK FOOTER //
// ./src/ducks/testing.js